import React from 'react';
import superagent from 'superagent';

export default function withDataLoader(App) {
	return class extends React.Component {
		constructor(props) {
			super(props);
			this.loadDataAsync = this.loadDataAsync.bind(this);
		}

		loadDataAsync(fileNameList) {
			if (this.props.manualData && this.props.manualData.length) {
				return Promise.all(
					this.props.manualData.map(
						(manualDataEntry) =>
							new Promise((resolve) => {
								resolve({
									body: manualDataEntry
								});
							})
					)
				);
			}
			return Promise.all(
				fileNameList.map((fileName) => superagent.get(`${this.props.rootUrl}${fileName}`))
			);
		}

		render() {
			return <App {...this.props} loadDataAsync={this.loadDataAsync} />;
		}
	};
}

